// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { Modal, Button } from 'react-bootstrap';
// import 'react-datepicker/dist/react-datepicker.css';
// import Headstu from '../StudentLogin/Headstu';
// import axios from '../Axiosinstance';
// import { CLOUDINARY_UPLOAD_PRESET, baseURL,timestamp } from '../common';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import './Prostu.css'
// import TextField from '@mui/material/TextField';
// import bcrypt from 'bcryptjs';
// import { Typography, CardContent, CardHeader, Avatar, Grid, Box, Container, Card } from '@mui/material';
// import { decryptData } from '../Axiosinstance';


// const Newbatch = () => {
//   const [userData, setUserData] = useState({
//     id: '',
//     username: '',
//     password: '',
//     email: '',
//     usertype: 0,
//     sfid: 0,
//     profile_Url: '',
//     name: '',
//   });

//   const [uploadedFileUrl, setUploadedFileUrl] = useState('');
//   const [modalOpen, setModalOpen] = useState(false); // State for modal visibility
//   const [oldpassword, setOldPassword] = useState('');
//   const [newPassword, setNewPassword] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');


//   useEffect(() => {
//     // Retrieve the id from local storage
//     const id = decryptData(localStorage.getItem('userId'));

//     if (id) {
//       // Make an API request to get user data
//       axios.get(`home/user/${id}`)
//         .then((response) => {
//           const userDataResponse = response.data;
//           // Update the state with the response data
//           setUserData(userDataResponse);
//         })
//         .catch((error) => {
//           console.error('Error fetching user data:', error);
//         });
//     }
//   }, []);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setUserData({ ...userData, [name]: value });
//   };

//   const handleFileUpload = async (e) => {
//     const file = e.target.files[0];

//     if (file) {
//       const formData = new FormData();
//       formData.append('file', file);
//       formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
//       formData.append('public_id', 'LMS/profile/' + file.name +' - '+ timestamp);

//       try {
//         const response = await fetch(baseURL, {
//           method: 'POST',
//           body: formData,
//         });
//         const data = await response.json();
//         if (data.secure_url !== '') {
//           const url = data.secure_url;
//           setUploadedFileUrl(url);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }
//   };

//   // Function to handle saving changes
//   const handleSaveChanges = () => {
//     // Make a PUT request to update user details
//     axios
//       .put(`/home/user/${userData.userId}`, {
//         ...userData,
//         profile_Url: uploadedFileUrl || userData.profile_Url, // Use the uploadedFileUrl if available, else retain the existing URL
//       })
//       .then((response) => {
//         // Handle success, e.g., show a success message
//         console.log('User details updated:', response.data);
//         toast.success('User details updated successfully!', {
//           position: 'bottom-right',
//           autoClose: 3000, // Close the toast after 3 seconds
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
          
//         });
//         window.location.reload();
//       })
//       .catch((error) => {
//         // Handle errors, e.g., show an error message
//         console.error('Error updating user details:', error);
//         toast.error('Error updating user details. Please try again.', {
//           position: 'bottom-right',
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//         });
//       });
//   };


//   const handleChangePassword = async () => {
//     // Check if the old password matches the stored hashed password
//     const isMatch = await bcrypt.compare(oldpassword, userData.password);

//     if (isMatch) {
//       // Hash the new password
//       const salt = await bcrypt.genSalt(10);
//       const hashedNewPassword = await bcrypt.hash(newPassword, salt);

//       // Create an updated user data object
//       const updatedUserData = {
//         ...userData, // spread existing user data
//         password: hashedNewPassword, // replace the old password with the new hashed password
//       };

//       console.log('Updated user data:', updatedUserData); // Log the updated user data

//       // Make a PUT request to update user details
//       axios.put(`/home/user/${userData.userId}`, updatedUserData)
//         .then(response => {
//           toast.success('User details updated successfully!', {
//             position: 'bottom-right',
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//           });

//           // Close the modal after successful update
//           setModalOpen(false);

//           // Clear the modal input fields
//           setOldPassword('');
//           setNewPassword('');
//           setErrorMessage('');
//           window.location.reload();

//         })
//         .catch(error => {
//           console.error('Error updating user details:', error);
//           toast.error('Error updating user details. Please try again.', {
//             position: 'bottom-right',
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//           });
//         });
//     } else {
//       setErrorMessage('Old password is incorrect.');
//     }
//   };

//   return (
//     <Container maxWidth="md" >
//       <Box my={4} style={{ width: '100%' }
//       }>
//         <Typography variant="h4" gutterBottom align="left" style={{ marginBottom: '20px' }}>
//           <Link to="/profile" style={{ textDecoration: 'none', color: '#3f51b5', fontWeight: 'bolder' }}>Student Profile </Link>
//         </Typography>
//         < Card elevation={3} style={{ padding: '20px' }}>
//           <CardHeader
//             title="Account Details"
//             avatar={< Avatar src={userData.profile_Url} alt="Profile" />}
//             titleTypographyProps={{ variant: 'h6', align: 'left' }}
//             style={{ textAlign: 'left' }}
//           />
//           < CardContent >
//             <form>
//               <Grid container spacing={3} >
//                 <Grid item xs={12} sm={6} >
//                   <TextField
//                     fullWidth
//                     label="Username"
//                     id="inputUsername"
//                     name="name"
//                     type="text"
//                     value={userData.name}
//                     onChange={handleInputChange}
//                     variant="outlined"
//                   />
//                 </Grid>
//                 < Grid item xs={12} sm={6} >
//                   <TextField
//                     className="form-control"
//                     fullWidth
//                     label="Email"
//                     id="inputEmail"
//                     name="email"
//                     type="email"
// disabled
//                     value={userData.email}
//                     onChange={handleInputChange}
//                     variant="outlined"
//                   />
//                 </Grid>

//   < Grid item xs={12} >
//                   <label htmlFor="fileupload" style={{ fontWeight: 'bold' }}> Upload Profile Image </label>
//                   <input type="file" id="fileupload" onChange={handleFileUpload} style={{ marginTop: '10px', display: 'block' }} /><br />
//                   {userData.profile_Url && (
//                     <Box mt={2} textAlign="center" >
//                       <img src={userData.profile_Url} alt="Profile" style={{ width: '150px', height: '150px' }} />
//                     </Box>
//                   )}
//                 </Grid>
//               </Grid>
//                   < Box mt={3} textAlign="center" >
//                 {/* <Button variant="contained" color="primary" onClick={() => setModalOpen(true)} style={{ marginRight: '10px' }} >Change Password</Button> */}
//                     <Button
//                   type="button"
//                   variant="contained"
//                   color="success"
//                   onClick={handleSaveChanges}

//                 >
//                   Save Changes
//                 </Button>
//               </Box>
//             </form>
//           </CardContent>
//         </Card>


//               {/* Password Change Modal */}
//               <Modal centered show={modalOpen} onHide={() => {
//                 setModalOpen(false);
//                 // Clear the modal input fields
//                 setOldPassword('');
//                 setNewPassword('');
//                 setErrorMessage(''); // Clear any existing error message as well
//               }}>
//                 <Modal.Header closeButton>
//                   <Modal.Title>Change Password</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                   {/* Password change form goes here */}
//                   <TextField
//                     label="Enter old password"
//                     name="oldpassword"
//                     value={oldpassword}
//                     onChange={(e) => setOldPassword(e.target.value)}
//                     fullWidth
//                     margin="normal"
//                      variant="outlined"
//                   // required
//                   />
//                   {errorMessage && <Typography color="error">{errorMessage}</Typography>}
//                   <TextField
//                     label="Enter new password"
//                     name="newPassword"
//                     value={newPassword}
//                     onChange={(e) => setNewPassword(e.target.value)}
//                     fullWidth
//                     margin="normal"
//                     variant="outlined"
//                   />

//                 </Modal.Body>
//                 <Modal.Footer>
//                   <Button variant="secondary" onClick={() => setModalOpen(false)}>
//                     Close
//                   </Button>
//                   <Button variant="primary" onClick={handleChangePassword}>
//                     Save
//                   </Button>
//                 </Modal.Footer>
//               </Modal>
//               </Box>
//       < ToastContainer />
//     </Container>

//   );
// };


// const NewbatchPage = () => {
//   return (
//     <div>
//       <Headstu />
//        <Newbatch />      
//     </div>
//   );
// };

// export default NewbatchPage;



// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { Modal, Button } from 'react-bootstrap';
// import 'react-datepicker/dist/react-datepicker.css';
// import Headstu from '../StudentLogin/Headstu';
// import axios from '../Axiosinstance';
// import { CLOUDINARY_UPLOAD_PRESET, baseURL,timestamp } from '../common';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import './Prostu.css'
// import TextField from '@mui/material/TextField';
// import bcrypt from 'bcryptjs';
// import { Typography, CardContent, CardHeader, Avatar, Grid, Box, Container, Card } from '@mui/material';
// import { decryptData } from '../Axiosinstance';


// const Newbatch = () => {
//   const [userData, setUserData] = useState({
//     id: '',
//     username: '',
//     password: '',
//     email: '',
//     usertype: 0,
//     sfid: 0,
//     profile_Url: '',
//     name: '',
//   });

//   const [uploadedFileUrl, setUploadedFileUrl] = useState('');
//   const [modalOpen, setModalOpen] = useState(false); // State for modal visibility
//   const [oldpassword, setOldPassword] = useState('');
//   const [newPassword, setNewPassword] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');


//   useEffect(() => {
//     // Retrieve the id from local storage
//     const id = decryptData(localStorage.getItem('userId'));

//     if (id) {
//       // Make an API request to get user data
//       axios.get(`home/user/${id}`)
//         .then((response) => {
//           const userDataResponse = response.data;
//           // Update the state with the response data
//           setUserData(userDataResponse);
//         })
//         .catch((error) => {
//           console.error('Error fetching user data:', error);
//         });
//     }
//   }, []);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setUserData({ ...userData, [name]: value });
//   };

//   const handleFileUpload = async (e) => {
//     const file = e.target.files[0];

//     if (file) {
//       const formData = new FormData();
//       formData.append('file', file);
//       formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
//       formData.append('public_id', 'LMS/profile/' + file.name +' - '+ timestamp);

//       try {
//         const response = await fetch(baseURL, {
//           method: 'POST',
//           body: formData,
//         });
//         const data = await response.json();
//         if (data.secure_url !== '') {
//           const url = data.secure_url;
//           setUploadedFileUrl(url);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }
//   };

//   // Function to handle saving changes
//   const handleSaveChanges = () => {
//     // Make a PUT request to update user details
//     axios
//       .put(`/home/user/${userData.userId}`, {
//         ...userData,
//         profile_Url: uploadedFileUrl || userData.profile_Url, // Use the uploadedFileUrl if available, else retain the existing URL
//       })
//       .then((response) => {
//         // Handle success, e.g., show a success message
//         console.log('User details updated:', response.data);
//         toast.success('User details updated successfully!', {
//           position: 'bottom-right',
//           autoClose: 3000, // Close the toast after 3 seconds
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
          
//         });
//         window.location.reload();
//       })
//       .catch((error) => {
//         // Handle errors, e.g., show an error message
//         console.error('Error updating user details:', error);
//         toast.error('Error updating user details. Please try again.', {
//           position: 'bottom-right',
//           autoClose: 3000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//         });
//       });
//   };


//   const handleChangePassword = async () => {
//     // Check if the old password matches the stored hashed password
//     const isMatch = await bcrypt.compare(oldpassword, userData.password);

//     if (isMatch) {
//       // Hash the new password
//       const salt = await bcrypt.genSalt(10);
//       const hashedNewPassword = await bcrypt.hash(newPassword, salt);

//       // Create an updated user data object
//       const updatedUserData = {
//         ...userData, // spread existing user data
//         password: hashedNewPassword, // replace the old password with the new hashed password
//       };

//       console.log('Updated user data:', updatedUserData); // Log the updated user data

//       // Make a PUT request to update user details
//       axios.put(`/home/user/${userData.userId}`, updatedUserData)
//         .then(response => {
//           toast.success('User details updated successfully!', {
//             position: 'bottom-right',
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//           });

//           // Close the modal after successful update
//           setModalOpen(false);

//           // Clear the modal input fields
//           setOldPassword('');
//           setNewPassword('');
//           setErrorMessage('');
//           window.location.reload();

//         })
//         .catch(error => {
//           console.error('Error updating user details:', error);
//           toast.error('Error updating user details. Please try again.', {
//             position: 'bottom-right',
//             autoClose: 3000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//           });
//         });
//     } else {
//       setErrorMessage('Old password is incorrect.');
//     }
//   };

//   return (
//     <Container maxWidth="md" >
//       <Box my={4} style={{ width: '100%' }
//       }>
//         <Typography variant="h4" gutterBottom align="left" style={{ marginBottom: '20px' }}>
//           <Link to="/profile" style={{ textDecoration: 'none', color: '#3f51b5', fontWeight: 'bolder' }}>Student Profile </Link>
//         </Typography>
//         < Card elevation={3} style={{ padding: '20px' }}>
//           <CardHeader
//             title="Account Details"
//             avatar={< Avatar src={userData.profile_Url} alt="Profile" />}
//             titleTypographyProps={{ variant: 'h6', align: 'left' }}
//             style={{ textAlign: 'left' }}
//           />
//           < CardContent >
//             <form>
//               <Grid container spacing={3} >
//                 <Grid item xs={12} sm={6} >
//                   <TextField
//                     fullWidth
//                     label="Username"
//                     id="inputUsername"
//                     name="name"
//                     type="text"
//                     value={userData.name}
//                     onChange={handleInputChange}
//                     variant="outlined"
//                   />
//                 </Grid>
//                 < Grid item xs={12} sm={6} >
//                   <TextField
//                     className="form-control"
//                     fullWidth
//                     label="Email"
//                     id="inputEmail"
//                     name="email"
//                     type="email"
// disabled
//                     value={userData.email}
//                     onChange={handleInputChange}
//                     variant="outlined"
//                   />
//                 </Grid>

//   < Grid item xs={12} >
//                   <label htmlFor="fileupload" style={{ fontWeight: 'bold' }}> Upload Profile Image </label>
//                   <input type="file" id="fileupload" onChange={handleFileUpload} style={{ marginTop: '10px', display: 'block' }} /><br />
//                   {userData.profile_Url && (
//                     <Box mt={2} textAlign="center" >
//                       <img src={userData.profile_Url} alt="Profile" style={{ width: '150px', height: '150px' }} />
//                     </Box>
//                   )}
//                 </Grid>
//               </Grid>
//                   < Box mt={3} textAlign="center" >
//                 {/* <Button variant="contained" color="primary" onClick={() => setModalOpen(true)} style={{ marginRight: '10px' }} >Change Password</Button> */}
//                     <Button
//                   type="button"
//                   variant="contained"
//                   color="success"
//                   onClick={handleSaveChanges}

//                 >
//                   Save Changes
//                 </Button>
//               </Box>
//             </form>
//           </CardContent>
//         </Card>


//               {/* Password Change Modal */}
//               <Modal centered show={modalOpen} onHide={() => {
//                 setModalOpen(false);
//                 // Clear the modal input fields
//                 setOldPassword('');
//                 setNewPassword('');
//                 setErrorMessage(''); // Clear any existing error message as well
//               }}>
//                 <Modal.Header closeButton>
//                   <Modal.Title>Change Password</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                   {/* Password change form goes here */}
//                   <TextField
//                     label="Enter old password"
//                     name="oldpassword"
//                     value={oldpassword}
//                     onChange={(e) => setOldPassword(e.target.value)}
//                     fullWidth
//                     margin="normal"
//                      variant="outlined"
//                   // required
//                   />
//                   {errorMessage && <Typography color="error">{errorMessage}</Typography>}
//                   <TextField
//                     label="Enter new password"
//                     name="newPassword"
//                     value={newPassword}
//                     onChange={(e) => setNewPassword(e.target.value)}
//                     fullWidth
//                     margin="normal"
//                     variant="outlined"
//                   />

//                 </Modal.Body>
//                 <Modal.Footer>
//                   <Button variant="secondary" onClick={() => setModalOpen(false)}>
//                     Close
//                   </Button>
//                   <Button variant="primary" onClick={handleChangePassword}>
//                     Save
//                   </Button>
//                 </Modal.Footer>
//               </Modal>
//               </Box>
//       < ToastContainer />
//     </Container>

//   );
// };


// const NewbatchPage = () => {
//   return (
//     <div>
//       <Headstu />
//        <Newbatch />      
//     </div>
//   );
// };

// export default NewbatchPage;





import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import Headstu from '../StudentLogin/Headstu';
import axios from '../Axiosinstance';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TextField from '@mui/material/TextField';
import bcrypt from 'bcryptjs';
import {
  Typography, CardContent, CardHeader, Avatar, Grid, Box,
  Container, Card, Button as MuiButton, Chip, Divider, IconButton,
  InputAdornment
} from '@mui/material';
import {
  Email, Person, Lock, Visibility, VisibilityOff,
  Badge as BadgeIcon, Edit as EditIcon
} from '@mui/icons-material';
import { decryptData } from '../Axiosinstance';
import { StudentDetailsModal } from '../Batchescourserun/Manage';

const Newbatch = () => {
  const [userData, setUserData] = useState({
    id: '',
    username: '',
    password: '',
    email: '',
    usertype: 0,
    sfid: 0,
    profile_Url: '',
    name: '',
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [oldpassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showOldPw, setShowOldPw] = useState(false);
  const [showNewPw, setShowNewPw] = useState(false);
  const [showConfirmPw, setShowConfirmPw] = useState(false);

  const [showProfileModal, setShowProfileModal] = useState(false);
  const [profileStudentData, setProfileStudentData] = useState(null);
  const [profileLoading, setProfileLoading] = useState(false);

  useEffect(() => {
    const id = decryptData(localStorage.getItem('userId'));
    if (id) {
      axios.get(`home/user/${id}`)
        .then((response) => {
          setUserData(response.data);
        })
        .catch((error) => {
          console.error('Error fetching user data:', error);
        });
    }
  }, []);

  const handleViewFullProfile = async () => {
    try {
      setProfileLoading(true);
      setShowProfileModal(true);
      const response = await axios.get(`/registrationadvances/${userData.sfid}`);
      // Ensure profileUrl is populated from user data if not in registration data
      const data = response.data;
      if (!data.profileUrl && userData.profile_Url) {
        data.profileUrl = userData.profile_Url;
      }
      setProfileStudentData(data);
    } catch (err) {
      console.error('Error fetching student profile:', err);
      toast.error('Failed to load profile details.');
    } finally {
      setProfileLoading(false);
    }
  };

  const handleChangePassword = async () => {
    setErrorMessage('');
    if (newPassword !== confirmPassword) {
      setErrorMessage('New passwords do not match.');
      return;
    }
    if (newPassword.length < 6) {
      setErrorMessage('Password must be at least 6 characters.');
      return;
    }
    const isMatch = await bcrypt.compare(oldpassword, userData.password);
    if (isMatch) {
      const salt = await bcrypt.genSalt(10);
      const hashedNewPassword = await bcrypt.hash(newPassword, salt);
      const updatedUserData = { ...userData, password: hashedNewPassword };
      axios.put(`/home/user/${userData.userId}`, updatedUserData)
        .then(() => {
          toast.success('Password updated successfully!', { position: 'bottom-right', autoClose: 3000 });
          setModalOpen(false);
          setOldPassword('');
          setNewPassword('');
          setConfirmPassword('');
          setErrorMessage('');
        })
        .catch(() => {
          toast.error('Error updating password. Please try again.', { position: 'bottom-right', autoClose: 3000 });
        });
    } else {
      setErrorMessage('Old password is incorrect.');
    }
  };

  const getInitials = (name) => {
    if (!name) return '?';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=DM+Sans:wght@300;400;500;600&display=swap');

        .profile-page {
          min-height: 100vh;
          background: #f0f4f8;
          font-family: 'DM Sans', sans-serif;
        }

        .profile-hero {
          background: linear-gradient(135deg, #1a2744 0%, #2d4a8a 60%, #3d6cb5 100%);
          padding: 48px 0 80px;
          position: relative;
          overflow: hidden;
        }

        .profile-hero::before {
          content: '';
          position: absolute;
          top: -60px; right: -60px;
          width: 300px; height: 300px;
          border-radius: 50%;
          background: rgba(255,255,255,0.04);
        }

        .profile-hero::after {
          content: '';
          position: absolute;
          bottom: -80px; left: -40px;
          width: 220px; height: 220px;
          border-radius: 50%;
          background: rgba(255,255,255,0.03);
        }

        .hero-avatar {
          width: 100px !important;
          height: 100px !important;
          border: 4px solid rgba(255,255,255,0.3) !important;
          font-size: 2rem !important;
          background: linear-gradient(135deg, #4776e6, #8e54e9) !important;
          font-family: 'Playfair Display', serif !important;
          box-shadow: 0 8px 32px rgba(0,0,0,0.3) !important;
        }

        .hero-name {
          font-family: 'Playfair Display', serif !important;
          font-size: 1.8rem !important;
          font-weight: 700 !important;
          color: #ffffff !important;
          letter-spacing: -0.3px;
        }

        .hero-email {
          color: rgba(255,255,255,0.7) !important;
          font-size: 0.95rem !important;
        }

        .profile-cards-wrapper {
          margin-top: -40px;
          position: relative;
          z-index: 10;
          padding: 0 24px 40px;
        }

        .info-card {
          background: #ffffff !important;
          border-radius: 16px !important;
          box-shadow: 0 4px 24px rgba(0,0,0,0.08) !important;
          border: 1px solid rgba(0,0,0,0.05) !important;
          overflow: hidden;
          transition: box-shadow 0.2s ease;
        }

        .info-card:hover {
          box-shadow: 0 8px 32px rgba(0,0,0,0.12) !important;
        }

        .card-section-title {
          font-family: 'DM Sans', sans-serif !important;
          font-size: 0.7rem !important;
          font-weight: 600 !important;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          color: #94a3b8 !important;
          padding: 20px 24px 8px !important;
        }

        .info-row {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 14px 24px;
          border-bottom: 1px solid #f1f5f9;
          transition: background 0.15s;
        }

        .info-row:last-child {
          border-bottom: none;
        }

        .info-row:hover {
          background: #f8fafc;
        }

        .info-icon {
          width: 36px !important;
          height: 36px !important;
          border-radius: 10px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          flex-shrink: 0 !important;
        }

        .info-label {
          font-size: 0.72rem !important;
          font-weight: 600 !important;
          color: #94a3b8 !important;
          text-transform: uppercase;
          letter-spacing: 0.8px;
          display: block;
          margin-bottom: 1px;
        }

        .info-value {
          font-size: 0.95rem !important;
          font-weight: 500 !important;
          color: #1e293b !important;
        }

        .action-btn {
          border-radius: 10px !important;
          padding: 10px 20px !important;
          font-family: 'DM Sans', sans-serif !important;
          font-weight: 600 !important;
          font-size: 0.88rem !important;
          text-transform: none !important;
          letter-spacing: 0;
          transition: all 0.2s ease !important;
        }

        .btn-change-pw {
          background: #f8fafc !important;
          color: #1a2744 !important;
          border: 1.5px solid #e2e8f0 !important;
        }

        .btn-change-pw:hover {
          background: #f1f5f9 !important;
          border-color: #cbd5e1 !important;
        }

        .btn-view-profile {
          background: linear-gradient(135deg, #1a2744, #2d4a8a) !important;
          color: #ffffff !important;
          border: none !important;
          box-shadow: 0 4px 16px rgba(26,39,68,0.25) !important;
        }

        .btn-view-profile:hover {
          transform: translateY(-1px);
          box-shadow: 0 6px 20px rgba(26,39,68,0.35) !important;
        }

        /* Password Modal Styles */
        .pw-modal .modal-content {
          border-radius: 20px !important;
          border: none !important;
          overflow: hidden;
        }

        .pw-modal .modal-header {
          background: linear-gradient(135deg, #1a2744, #2d4a8a);
          border: none !important;
          padding: 20px 24px !important;
        }

        .pw-modal .modal-title {
          font-family: 'Playfair Display', serif !important;
          font-size: 1.2rem !important;
          color: white !important;
        }

        .pw-modal .btn-close {
          filter: invert(1) !important;
        }

        .pw-modal .modal-body {
          padding: 28px 24px !important;
        }

        .pw-modal .modal-footer {
          border-top: 1px solid #f1f5f9 !important;
          padding: 16px 24px !important;
        }

        .pw-field .MuiOutlinedInput-root {
          border-radius: 10px !important;
        }

        .pw-field .MuiInputLabel-root {
          font-family: 'DM Sans', sans-serif !important;
        }

        .error-msg {
          background: #fef2f2;
          border: 1px solid #fecaca;
          border-radius: 8px;
          padding: 10px 14px;
          color: #dc2626;
          font-size: 0.85rem;
          font-weight: 500;
          margin-top: 4px;
        }
      `}</style>

      <div className="profile-page">
        {/* Hero Section */}
        <div className="profile-hero">
          <Container maxWidth="md">
            <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
              <Avatar className="hero-avatar" src={userData.profile_Url}>
                {!userData.profile_Url && getInitials(userData.name)}
              </Avatar>
              <Box textAlign="center">
                <Typography className="hero-name">{userData.name || 'Student'}</Typography>
                <Typography className="hero-email">{userData.email}</Typography>
              </Box>
              <Chip
                label="Student"
                size="small"
                sx={{
                  background: 'rgba(255,255,255,0.15)',
                  color: 'white',
                  fontFamily: 'DM Sans',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  letterSpacing: '0.5px',
                  border: '1px solid rgba(255,255,255,0.25)'
                }}
              />
            </Box>
          </Container>
        </div>

        {/* Cards Section */}
        <Container maxWidth="md">
          <div className="profile-cards-wrapper">
            <Grid container spacing={3}>

              {/* Account Information Card */}
              <Grid item xs={12}>
                <div className="info-card">
                  <Typography className="card-section-title">Account Information</Typography>

                  <div className="info-row">
                    <Box
                      className="info-icon"
                      sx={{ background: 'linear-gradient(135deg, #dbeafe, #bfdbfe)' }}
                    >
                      <Person sx={{ fontSize: 18, color: '#1d4ed8' }} />
                    </Box>
                    <Box>
                      <span className="info-label">Full Name</span>
                      <Typography className="info-value">{userData.name || '—'}</Typography>
                    </Box>
                  </div>

                  <div className="info-row">
                    <Box
                      className="info-icon"
                      sx={{ background: 'linear-gradient(135deg, #dcfce7, #bbf7d0)' }}
                    >
                      <Email sx={{ fontSize: 18, color: '#16a34a' }} />
                    </Box>
                    <Box>
                      <span className="info-label">Email Address</span>
                      <Typography className="info-value">{userData.email || '—'}</Typography>
                    </Box>
                  </div>

                  <div className="info-row">
                    <Box
                      className="info-icon"
                      sx={{ background: 'linear-gradient(135deg, #fef3c7, #fde68a)' }}
                    >
                      <Lock sx={{ fontSize: 18, color: '#d97706' }} />
                    </Box>
                    <Box flex={1}>
                      <span className="info-label">Password</span>
                      <Typography className="info-value">••••••••••••</Typography>
                    </Box>
                    <MuiButton
                      className="action-btn btn-change-pw"
                      size="small"
                      startIcon={<EditIcon sx={{ fontSize: '15px !important' }} />}
                      onClick={() => setModalOpen(true)}
                    >
                      Change
                    </MuiButton>
                  </div>
                </div>
              </Grid>

              {/* Actions Card */}
              {userData.sfid && (
                <Grid item xs={12}>
                  <div className="info-card">
                    <Typography className="card-section-title">My Profile</Typography>
                    <Box p={3} display="flex" alignItems="center" justifyContent="space-between">
                      <Box>
                        <Typography sx={{
                          fontFamily: 'DM Sans',
                          fontWeight: 600,
                          color: '#1e293b',
                          fontSize: '0.95rem'
                        }}>
                          Full Student Profile
                        </Typography>
                        <Typography sx={{
                          fontFamily: 'DM Sans',
                          color: '#64748b',
                          fontSize: '0.82rem',
                          mt: 0.3
                        }}>
                          View your complete registration details, education & more
                        </Typography>
                      </Box>
                      <MuiButton
                        className="action-btn btn-view-profile"
                        onClick={handleViewFullProfile}
                      >
                        View Profile
                      </MuiButton>
                    </Box>
                  </div>
                </Grid>
              )}

            </Grid>
          </div>
        </Container>
      </div>

      {/* Change Password Modal */}
      <Modal
        centered
        show={modalOpen}
        className="pw-modal"
        onHide={() => {
          setModalOpen(false);
          setOldPassword('');
          setNewPassword('');
          setConfirmPassword('');
          setErrorMessage('');
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box display="flex" flexDirection="column" gap={2.5}>
            <TextField
              className="pw-field"
              label="Current Password"
              type={showOldPw ? 'text' : 'password'}
              value={oldpassword}
              onChange={(e) => setOldPassword(e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setShowOldPw(!showOldPw)}>
                      {showOldPw ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <TextField
              className="pw-field"
              label="New Password"
              type={showNewPw ? 'text' : 'password'}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setShowNewPw(!showNewPw)}>
                      {showNewPw ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <TextField
              className="pw-field"
              label="Confirm New Password"
              type={showConfirmPw ? 'text' : 'password'}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setShowConfirmPw(!showConfirmPw)}>
                      {showConfirmPw ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            {errorMessage && (
              <div className="error-msg">{errorMessage}</div>
            )}
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalOpen(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleChangePassword}
            style={{ background: 'linear-gradient(135deg, #1a2744, #2d4a8a)', border: 'none' }}
          >
            Update Password
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Full Student Profile Modal */}
      <StudentDetailsModal
        open={showProfileModal}
        onClose={() => { setShowProfileModal(false); setProfileStudentData(null); }}
        studentData={profileStudentData}
        loading={profileLoading}
      />

      <ToastContainer />
    </>
  );
};

const NewbatchPage = () => {
  return (
    <div>
      <Headstu />
      <Newbatch />
    </div>
  );
};

export default NewbatchPage;